import { Component } from '@angular/core';
import { WorkflowBaseDroppedField } from '../base-dropped-field.component';

@Component({
  selector: 'app-workflow-droppable-qr-code-field',
  templateUrl: './qr-code.component.html',
  styleUrls: ['../../droppable-field.component.scss']
})
export class WorkflowDroppableQrCodeFieldComponent extends WorkflowBaseDroppedField {}
